// import $ from 'jquery'


// export {
//   TinyMCEFloor,
//   TinyMCEFloorHeader
// }

// (function () {

// })();



// WEBPACK FOOTER //
// ./scripts/main.js